module.exports = __webpack_public_path__ + "static/media/invest.44a6d55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invest.png
// module id = 872
// module chunks = 3